import { jsx as _jsx } from "react/jsx-runtime";
import { useHandleUploadableMedia } from './useHandleUploadableMedia';
import { VariantAvatar } from './VariantAvatar';
import { VariantCompact } from './VariantCompact';
import { VariantDefault } from './VariantDefault';
const isMultiple = (props) => props.multiple === true;
const defaultConfig = {
    emoji: false,
    link: true,
    unsplash: true,
};
export const FormImageUpload = (props) => {
    const { variant = 'default', 
    // eslint-disable-next-line unused-imports/no-unused-vars
    onChange, 
    // eslint-disable-next-line unused-imports/no-unused-vars
    value, onError, config = defaultConfig, ...rest } = props;
    const multiple = isMultiple(props);
    let defaultValue;
    if (multiple) {
        defaultValue = props.value || [];
    }
    else {
        defaultValue = props.value ? [props.value] : [];
    }
    const onSuccess = newValue => {
        var _a, _b;
        if (multiple) {
            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, newValue);
        }
        else {
            (_b = props.onChange) === null || _b === void 0 ? void 0 : _b.call(props, newValue === null || newValue === void 0 ? void 0 : newValue[0]);
        }
    };
    const { medias, onImageUpload, onEmojiChange, onRemove } = useHandleUploadableMedia({
        defaultValue,
        multiple,
        onChange: onSuccess,
        onError,
    });
    const images = medias === null || medias === void 0 ? void 0 : medias.filter(it => it.name !== 'Emoji');
    switch (variant) {
        case 'compact':
            return (_jsx(VariantCompact, { image: medias === null || medias === void 0 ? void 0 : medias[0], onChange: onImageUpload, onEmojiChange: config.emoji && onEmojiChange, onRemove: onRemove, ...rest }, void 0));
        case 'avatar':
            return (_jsx(VariantAvatar, { image: images === null || images === void 0 ? void 0 : images[0], onChange: file => onImageUpload([file]), ...rest }, void 0));
        case 'default':
        default:
            return (_jsx(VariantDefault, { images: images, multiple: multiple, onChange: onImageUpload, onRemove: onRemove, config: config, ...rest }, void 0));
    }
};
//# sourceMappingURL=FormImageUpload.js.map